var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockSquareClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-square-closed",
    clipPath: "url(#clip0_4573_29446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 6.28655V4.57227C12 3.5114 11.5786 2.49398 10.8284 1.74384C10.0783 0.993693 9.06087 0.572266 8 0.572266C6.93913 0.572266 5.92172 0.993693 5.17157 1.74384C4.42143 2.49398 4 3.5114 4 4.57227V6.28655M12.5709 6.28655H3.42801C3.12491 6.28655 2.83422 6.40696 2.61989 6.62129C2.40556 6.83561 2.28516 7.1263 2.28516 7.42941V14.2866C2.28516 14.5897 2.40556 14.8803 2.61989 15.0947C2.83422 15.309 3.12491 15.4294 3.42801 15.4294H12.5709C12.874 15.4294 13.1647 15.309 13.379 15.0947C13.5933 14.8803 13.7137 14.5897 13.7137 14.2866V7.42941C13.7137 7.1263 13.5933 6.83561 13.379 6.62129C13.1647 6.40696 12.874 6.28655 12.5709 6.28655ZM7.99851 11.4294C8.15006 11.4294 8.29541 11.3692 8.40257 11.262C8.50974 11.1549 8.56994 11.0095 8.56994 10.858C8.56994 10.7064 8.50974 10.5611 8.40257 10.4539C8.29541 10.3467 8.15006 10.2865 7.99851 10.2865C7.84696 10.2865 7.70161 10.3467 7.59445 10.4539C7.48729 10.5611 7.42708 10.7064 7.42708 10.858C7.42708 11.0095 7.48729 11.1549 7.59445 11.262C7.70161 11.3692 7.84696 11.4294 7.99851 11.4294Z",
    stroke: "#040506",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4573_29446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSquareClosed);
export default __webpack_public_path__ + "static/media/lock-square-closed.eb3c499a0d37e85eb3b0bb7d4710faac.svg";
export { ForwardRef as ReactComponent };